module.exports = require('./helpers/bundle-url').getBundleURL('8kqgc') + "congrats-pregnant.d25ab5fd.png";